import { Box, Text } from '@mantine/core';
import { ANLAM } from '../theme';

/**
 * DEMO KİPİ (demo.safeops.com.tr — ✏️ 01.10.2026 taşındı, önce demo.safedeskplatform.com;
 * ürün sahibi kararları 23-25.09.2026;
 * docs/demo-kurulum.md).
 *
 * Tek anahtar: `VITE_DEMO_BANDI=1` DERLEME anında (apps/web/Dockerfile build
 * arg). Tanımsızsa şerit ÇİZİLMEZ — üretim güvencesi; e2e `demo-seridi.spec`
 * bunu ölçer (dev/CI derlemesinde değişken yoktur).
 *
 * ✏️ **NEREDE ÇİZİLİR (ürün sahibi 25.09.2026 — demo giriş paketi):** şerit
 * yalnız **oturumsuz QR sayfalarında** yaşar (`PublicBildirimScreen` ·
 * `PublicDegerlendirmeScreen`). **Giriş ekranı demo yüzeyi DEĞİLDİR:** demo
 * kipinde de uygulama üretimle aynı akışla Keycloak formuna yönlendirir; uyarı
 * o formun başlığında okunur (realm `displayNameHtml`, demo compose'unun
 * `ISG_GIRIS_BASLIGI` değeri). **Ana kabuk ve yüklenici portalı kabuğunda
 * ÇİZİLMEZ** (25.09 sabah kararı — uygulama içinde tasarım bütünlüğünü
 * bozuyordu, uyarı giriş anında zaten okunuyor).
 *
 * Revizyon izi: ~~24.09 "dört yüzey, App.tsx tek mount"~~ → ~~25.09 sabah
 * "giriş + iki QR sayfası"~~ → 25.09 demo giriş paketi **yalnız iki QR sayfası**.
 * Mount noktası bu yüzden yönlendiricinin üstünde değil, iki ekranın kendi
 * kökündedir; şerit akış içinde `sticky` durur, kabuk kayma hesabı yoktur.
 * Mount envanteri `demo-seridi.spec`te TAM EŞİTLİKLE kilitli (iki dosya).
 *
 * ⚠️ **PERSONA KARTLARI KALKTI (ürün sahibi 25.09.2026):** kimlik bilgileri
 * giriş ekranında yazmaz, ürün sahibi adaya **e-postayla** verir. Üç demo
 * hesabının Keycloak kullanıcı adı rol adıdır (`holding.yoneticisi` ·
 * `isg.uzmani` · `yuklenici` — realm yer tutucuları, sürüm 17); içerideki
 * kişi (Mehmet Yılmaz · Burak Yıldız · Hakan Yüce) ve seed eşlemesi (`sub`)
 * aynen. Bu dosya kullanıcı adı/parola TAŞIMAZ — tek kaynak realm + demo
 * compose'udur (docs/demo-kurulum.md §2).
 */
export const DEMO_KIPI = import.meta.env['VITE_DEMO_BANDI'] === '1';

export const DEMO_SERIT_METNI =
  'Demo ortamı — gerçek kişisel veri girmeyin. Veriler her gece sıfırlanır.';

/**
 * Şerit — akış içinde, yapışkan (sayfa kaydırılınca üstte kalır). Yalnız
 * oturumsuz iki QR sayfasının kökünde mount edilir (dosya başı yorumu); giriş
 * ekranı ve kabuk bileşenleri bunu import ETMEZ.
 */
export function DemoSeridi(): React.JSX.Element | null {
  if (!DEMO_KIPI) return null;
  return (
    <Box
      component="aside"
      role="note"
      aria-label="Demo ortamı uyarısı"
      data-testid="demo-seridi"
      pos="sticky"
      top={0}
      h="var(--isg-demo-serit-yukseklik)"
      px="md"
      bg={`${ANLAM.dikkat}.1`}
      c={`${ANLAM.dikkat}.9`}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 'calc(var(--mantine-z-index-app) + 1)',
      }}
    >
      <Text size="sm" fw={600} ta="center" lineClamp={1}>
        {DEMO_SERIT_METNI}
      </Text>
    </Box>
  );
}
